export function ImportRowInstructions(props) {
  return (
    <>
      <p>JSON must contain the following keynames and values:</p>
      <br />
      <b className="_display--block _margin-bottom--1rem">Required</b>

      <ul className="_list-style-position--inside _margin-left--1rem">
        <li className="_margin-bottom--1rem">
          <b>label</b>
          <ul className="_list-style-type--disc _list-style-position--inside">
            <li>Between 1 and 200 characters</li>
            <li>Can contain spaces and special characters, including emoji</li>
            <li>i.e. &apos;Some Interval&apos;</li>
          </ul>
        </li>
        <li className="_margin-bottom--1rem">
          <b>startTime</b>
          <ul className="_list-style-type--disc _list-style-position--inside">
            <li>Must be a datetime in ISO8601 format</li>
            <li>i.e. &apos;1789-04-30T12:00:00Z&apos;</li>
          </ul>
        </li>
        <li className="_margin-bottom--1rem">
          <b>endTime</b>
          <ul className="_list-style-type--disc _list-style-position--inside">
            <li>Must be a datetime in ISO8601 format</li>
            <li>i.e. &apos;1856-04-30T12:00:00Z&apos;</li>
          </ul>
        </li>
      </ul>
      <b className="_display--block _margin-bottom--1rem">Optional</b>
      <ul className="_list-style-position--inside _margin-left--1rem">
        <li className="_margin-bottom--1rem">
          <b>description</b>
          <ul className="_list-style-type--disc _list-style-position--inside">
            <li>Between 0 and 10,000 characters</li>
          </ul>
        </li>
        <li className="_margin-bottom--1rem">
          <b>primaryColor</b>
          <ul className="_list-style-type--disc _list-style-position--inside">
            <li>Must be lowercase</li>
            <li>
              See our detailed&nbsp;
              <a
                href="/documentation/formatting-guide"
                target="_blank"
                className="external_link"
              >
                formatting guide
              </a>
              &nbsp; for a list of available color names
            </li>
          </ul>
        </li>
        <li className="_margin-bottom--1rem">
          <b>secondaryColor</b>
          <ul className="_list-style-type--disc _list-style-position--inside">
            <li>Must be lowercase</li>
            <li>
              See our detailed&nbsp;
              <a
                href="/documentation/formatting-guide"
                target="_blank"
                className="external_link"
              >
                formatting guide
              </a>
              &nbsp; for a list of available color names
            </li>
          </ul>
        </li>
      </ul>
      <b>Example</b>
      <br />
      <pre className="_margin--0">{props.formatExample}</pre>
    </>
  );
}

export const ImportRowInstructionsDoordash = () => {
  return (
    <>
      <div className="_text-align--center _margin-bottom--1rem">
        <img src="/images/logos/doordash_logo.svg" style={{ height: "2rem" }} />
      </div>
      <p className="_margin-bottom--1rem">
        In order to import your Doordash orders, you will need to download your
        order history from Doordash.
      </p>

      <p className="_margin-bottom--1rem">
        Follow the steps below to download your Doordash order history:
      </p>
      <ol className="spaced_ordered_list _margin-left--1rem _list-style-type--auto">
        <li>Login to your Doordash account on your computer.</li>
        <li>
          Click on the &apos;Account&apos; icon at the bottom of the left
          sidebar
        </li>
        <li>
          In the resulting popup window, click the &apos;Account&apos; option,
          underneath the &apos;Account Settings&apos; section.
        </li>
        <li>On the resulting screen, click &apos;Manage Account&apos;.</li>
        <li>Click the &quot;Request Archive&quot; button.</li>
        <li>Complete the Two-Step Authentication process.</li>
        <li>Wait for the email from Doordash to arrive in your inbox.</li>
        <li>Download the zip file from the email.</li>
        <li>Unzip the file.</li>
        <li>
          Upload the <b>orders.csv</b> file from the unzipped folder here.
        </li>
      </ol>
    </>
  );
};
